import { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { register } from "@/services/Users/register";

export const Register = () => {
    const [user, setUser] = useState<{ id: number; username: string; role: string } | null>(null);
    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const onFinish = async (values: { username: string; password: string; confirmPassword: string }) => {
        if (values.password !== values.confirmPassword) {
            messageApi.error("Şifreler eşleşmiyor!");
            return;
        }

        setLoading(true);
        try {
            // register servisi artık token ve role'ü localStorage'a kaydediyor
            const res = await register(values.username, values.password);

            if (res.success) {
                setUser(res.user!); // component sadece state'i güncelliyor
                messageApi.success("Kayıt başarılı!");
            } else {
                messageApi.error(res.message || "Kayıt başarısız!");
            }
        } catch {
            messageApi.error("Kayıt sırasında bir hata oluştu");
        } finally {
            setLoading(false);
        }
    };

    if (user) {
        return (
            <div>
                {contextHolder}
                <h2>Hoşgeldiniz {user.username}</h2>
                <p>Role: {user.role}</p>
            </div>
        );
    }

    return (
        <div style={{ width: 300 }}>
            {contextHolder}
            <Form layout="vertical" onFinish={onFinish} autoComplete="off">
                <Form.Item
                    label="Kullanıcı Adı"
                    name="username"
                    rules={[{ required: true, message: "Kullanıcı adı gerekli!" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Şifre"
                    name="password"
                    rules={[{ required: true, message: "Şifre gerekli!" }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item
                    label="Şifreyi Onayla"
                    name="confirmPassword"
                    rules={[{ required: true, message: "Şifreyi onaylayın!" }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                        Kayıt Ol
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};
